import { useEffect } from "react";

/**
 * Marks the element `data-live` while any of it is on screen. The theme's looping
 * animations (petals, butterflies, swaying strings) are paused on pages that aren't
 * (styles/_base.scss), so only what the guest can see is moving.
 *
 * A data attribute rather than a class, so React never overwrites it on re-render.
 */
const useLive = (ref) => {
  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    if (typeof IntersectionObserver === "undefined") {
      el.dataset.live = "";
      return undefined;
    }
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) el.dataset.live = "";
      else delete el.dataset.live;
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, [ref]);
};

export default useLive;
